import React from 'react'
import { withTranslation } from 'react-i18next'

import { IconThunder } from '../svg'

const Toggle = ({
    theme = 'thunder',
    sizes = { width: 80, height: 40, offset: 3, imgWidth: 16 },
    isChecked = false,
    isDisabled = false,
    id,
    onChange,
    mainColor = '#2990FB',
    uncheckedColor = '#000000',
    circleColor = '#FFFFFF',
    t,
}) => {
    function handleChange(evt) {
        if (!isDisabled) {
            onChange(id, evt.target.checked)
        }
    }

    const randomInputID = '_' + Math.random().toString(36).substr(2, 9)

    let labelStyles = {
        backgroundColor: isChecked ? mainColor : uncheckedColor,
        width: sizes.width,
        height: sizes.height,
    }
    let circleStyles = {
        backgroundColor: circleColor,
        width: sizes.height - sizes.offset * 2,
        height: sizes.height - sizes.offset * 2,

        left: isChecked ? `calc(100% - ${sizes.height - sizes.offset}px)` : sizes.offset,
    }
    let bgImgStyles = {
        width: sizes.height,
        height: sizes.height,
    }

    return (
        <div className={`toggle-block${isDisabled ? ' is-disabled' : ''}`}>
            <input type="checkbox" id={randomInputID} checked={isChecked} onChange={handleChange} />
            <label htmlFor={randomInputID} style={labelStyles}>
                <div className="circle" style={circleStyles}>
                    {theme === 'thunder' ? <IconThunder color={mainColor} width={sizes.imgWidth} /> : null}
                </div>
                <div className="bg-img" style={bgImgStyles}>
                    {theme === 'thunder' ? (
                        <IconThunder color={circleColor} width={sizes.imgWidth} height={sizes.imgHeight} />
                    ) : null}
                </div>
            </label>
        </div>
    )
}

export default withTranslation('translations')(Toggle)
